// Walidacje przeniesione z prototypu — komunikaty w PL/EN bez przeredagowania.
import { checkTaxId } from "./tax-id.js";
const MSG = {
    pl: {
        name: "Podaj imię i nazwisko (min. 3 znaki).",
        email: "Podaj poprawny adres e-mail.",
        pass: "Hasło musi mieć min. 8 znaków.",
        pass2: "Hasła muszą być identyczne.",
        terms: "Wymagana akceptacja regulaminu.",
        nameReq: "Podaj nazwę.",
        empReq: "Podaj imię i nazwisko, e-mail oraz hasło.",
        empDup: "Konto z tym e-mailem już istnieje.",
        company: "Podaj nazwę firmy.",
        nip: "NIP musi mieć 10 cyfr i poprawną sumę kontrolną.",
        phone: "Podaj poprawny numer telefonu.",
        address: "Podaj adres firmy.",
        slug: "Subdomena: 3–63 znaki, małe litery, cyfry i myślnik (bez kropek).",
        slugTaken: "Ta subdomena jest już zajęta.",
        industries: "Wybierz co najmniej jedną branżę.",
        plan: "Wybierz plan.",
    },
    en: {
        name: "Enter your full name (min. 3 characters).",
        email: "Enter a valid e-mail address.",
        pass: "Password must be at least 8 characters.",
        pass2: "Passwords must match.",
        terms: "You must accept the terms.",
        nameReq: "Enter a name.",
        empReq: "Enter full name, e-mail and password.",
        empDup: "An account with this e-mail already exists.",
        company: "Enter the company name.",
        nip: "NIP must be 10 digits with a valid checksum.",
        phone: "Enter a valid phone number.",
        address: "Enter the company address.",
        slug: "Subdomain: 3–63 characters, lowercase letters, digits and hyphen (no dots).",
        slugTaken: "This subdomain is already taken.",
        industries: "Pick at least one industry.",
        plan: "Pick a plan.",
    },
    de: {
        name: "Bitte Vor- und Nachnamen angeben (mind. 3 Zeichen).",
        email: "Bitte eine gültige E-Mail-Adresse angeben.",
        pass: "Das Passwort muss mindestens 8 Zeichen haben.",
        pass2: "Die Passwörter müssen übereinstimmen.",
        terms: "Die AGB müssen akzeptiert werden.",
        nameReq: "Bitte einen Namen angeben.",
        empReq: "Bitte Name, E-Mail und Passwort angeben.",
        empDup: "Ein Konto mit dieser E-Mail existiert bereits.",
        company: "Bitte den Firmennamen angeben.",
        nip: "Die Steuernummer muss 10 Ziffern mit gültiger Prüfsumme haben.",
        phone: "Bitte eine gültige Telefonnummer angeben.",
        address: "Bitte die Firmenanschrift angeben.",
        slug: "Subdomain: 3–63 Zeichen, Kleinbuchstaben, Ziffern und Bindestrich (keine Punkte).",
        slugTaken: "Diese Subdomain ist bereits vergeben.",
        industries: "Bitte mindestens eine Branche wählen.",
        plan: "Bitte einen Tarif wählen.",
    },
    fr: {
        name: "Indiquez vos nom et prénom (3 caractères minimum).",
        email: "Indiquez une adresse e-mail valide.",
        pass: "Le mot de passe doit comporter au moins 8 caractères.",
        pass2: "Les mots de passe doivent être identiques.",
        terms: "Vous devez accepter les conditions.",
        nameReq: "Indiquez un nom.",
        empReq: "Indiquez le nom, l’e-mail et le mot de passe.",
        empDup: "Un compte avec cet e-mail existe déjà.",
        company: "Indiquez le nom de l’entreprise.",
        nip: "Le numéro fiscal doit comporter 10 chiffres avec une somme de contrôle valide.",
        phone: "Indiquez un numéro de téléphone valide.",
        address: "Indiquez l’adresse de l’entreprise.",
        slug: "Sous-domaine : 3 à 63 caractères, minuscules, chiffres et tiret (sans point).",
        slugTaken: "Ce sous-domaine est déjà pris.",
        industries: "Choisissez au moins un secteur.",
        plan: "Choisissez une formule.",
    },
    it: {
        name: "Inserisci nome e cognome (almeno 3 caratteri).",
        email: "Inserisci un indirizzo e-mail valido.",
        pass: "La password deve avere almeno 8 caratteri.",
        pass2: "Le password devono coincidere.",
        terms: "Devi accettare i termini.",
        nameReq: "Inserisci un nome.",
        empReq: "Inserisci nome, e-mail e password.",
        empDup: "Esiste già un account con questa e-mail.",
        company: "Inserisci la ragione sociale.",
        nip: "La partita IVA deve avere 10 cifre con checksum valido.",
        phone: "Inserisci un numero di telefono valido.",
        address: "Inserisci l’indirizzo dell’azienda.",
        slug: "Sottodominio: 3–63 caratteri, minuscole, cifre e trattino (senza punti).",
        slugTaken: "Questo sottodominio è già occupato.",
        industries: "Scegli almeno un settore.",
        plan: "Scegli un piano.",
    },
    es: {
        name: "Indica tu nombre y apellidos (mín. 3 caracteres).",
        email: "Indica una dirección de correo válida.",
        pass: "La contraseña debe tener al menos 8 caracteres.",
        pass2: "Las contraseñas deben coincidir.",
        terms: "Debes aceptar los términos.",
        nameReq: "Indica un nombre.",
        empReq: "Indica nombre, correo y contraseña.",
        empDup: "Ya existe una cuenta con este correo.",
        company: "Indica el nombre de la empresa.",
        nip: "El NIF debe tener 10 dígitos con suma de control válida.",
        phone: "Indica un número de teléfono válido.",
        address: "Indica la dirección de la empresa.",
        slug: "Subdominio: 3–63 caracteres, minúsculas, cifras y guion (sin puntos).",
        slugTaken: "Este subdominio ya está ocupado.",
        industries: "Elige al menos un sector.",
        plan: "Elige un plan.",
    },
    zh: {
        name: "请输入姓名（至少 3 个字符）。",
        email: "请输入有效的电子邮箱地址。",
        pass: "密码至少需要 8 个字符。",
        pass2: "两次输入的密码必须一致。",
        terms: "需要接受服务条款。",
        nameReq: "请输入名称。",
        empReq: "请输入姓名、邮箱和密码。",
        empDup: "该邮箱已注册账户。",
        company: "请输入公司名称。",
        nip: "税号须为 10 位数字且校验位正确。",
        phone: "请输入有效的电话号码。",
        address: "请输入公司地址。",
        slug: "子域名：3–63 个字符，小写字母、数字和连字符（不含句点）。",
        slugTaken: "该子域名已被占用。",
        industries: "请至少选择一个行业。",
        plan: "请选择套餐。",
    },
    ja: {
        name: "氏名を入力してください（3 文字以上）。",
        email: "有効なメールアドレスを入力してください。",
        pass: "パスワードは 8 文字以上で入力してください。",
        pass2: "パスワードが一致しません。",
        terms: "利用規約への同意が必要です。",
        nameReq: "名称を入力してください。",
        empReq: "氏名、メールアドレス、パスワードを入力してください。",
        empDup: "このメールアドレスのアカウントは既に存在します。",
        company: "会社名を入力してください。",
        nip: "納税者番号は 10 桁で、チェックディジットが正しい必要があります。",
        phone: "有効な電話番号を入力してください。",
        address: "会社の住所を入力してください。",
        slug: "サブドメイン：3〜63 文字、小文字・数字・ハイフン（ピリオド不可）。",
        slugTaken: "このサブドメインは既に使用されています。",
        industries: "業種を 1 つ以上選択してください。",
        plan: "プランを選択してください。",
    },
    ko: {
        name: "이름을 입력하세요(3자 이상).",
        email: "올바른 이메일 주소를 입력하세요.",
        pass: "비밀번호는 8자 이상이어야 합니다.",
        pass2: "비밀번호가 일치하지 않습니다.",
        terms: "이용약관에 동의해야 합니다.",
        nameReq: "이름을 입력하세요.",
        empReq: "이름, 이메일, 비밀번호를 입력하세요.",
        empDup: "이 이메일로 등록된 계정이 이미 있습니다.",
        company: "회사명을 입력하세요.",
        nip: "사업자번호는 10자리이며 검증번호가 올바라야 합니다.",
        phone: "올바른 전화번호를 입력하세요.",
        address: "회사 주소를 입력하세요.",
        slug: "서브도메인: 3~63자, 소문자·숫자·하이픈(마침표 불가).",
        slugTaken: "이미 사용 중인 서브도메인입니다.",
        industries: "업종을 하나 이상 선택하세요.",
        plan: "요금제를 선택하세요.",
    },
};
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
/**
 * Subdomena tenanta: 3–63 znaki, małe litery, cyfry i myślnik wewnątrz.
 *
 * Bez kropek — kropka tworzyłaby kolejny poziom subdomeny, poza zasięgiem certyfikatu
 * wildcard `*.b00k.online` i cookie SSO na `.b00k.online`. Zakres długości i zakaz
 * `--` na pozycjach 3–4 wynikają z reguł etykiety DNS (prefiks `xn--` jest zarezerwowany
 * dla punycode).
 */
export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])?$/;
const SLUG_PUNYCODE_RE = /^..--/;
/** Subdomeny zarezerwowane dla platformy. */
export const RESERVED_SLUGS = new Set([
    "www", "api", "auth", "admin", "mail", "status",
    "app", "id", "login", "static", "assets", "cdn", "docs", "help", "support",
    "billing", "b00k", "book", "keycloak", "no-reply", "noreply",
]);
export function validateAccount(f, lang = "pl") {
    const m = MSG[lang];
    const e = {};
    if (!f.name || f.name.trim().length < 3)
        e.name = m.name;
    if (!f.email || !EMAIL_RE.test(f.email))
        e.email = m.email;
    if (!f.pass || f.pass.length < 8)
        e.pass = m.pass;
    else if (f.pass2 !== f.pass)
        e.pass2 = m.pass2;
    if (!f.terms)
        e.terms = m.terms;
    return e;
}
export function validateLogin(f, lang = "pl") {
    const m = MSG[lang];
    const e = {};
    if (!f.email || !EMAIL_RE.test(f.email))
        e.email = m.email;
    if (!f.pass || f.pass.length < 8)
        e.pass = m.pass;
    return e;
}
/**
 * Czy numer podatkowy przechodzi tę samą ocenę, którą wydaje API.
 *
 * JEDNA reguła, nie dwie (ODS-B00-02, tundra ADR-0041 §6). Do 2026-09-06 stała
 * tu osobna, uboższa suma kontrolna — 10 cyfr bez prefiksu kraju — więc kreator
 * odbijał `PL5252344078` i każdy numer zagraniczny, które API przyjmowało
 * przez `checkTaxId`. Rozstrzyga `tax-id.ts`; ta funkcja jest tylko wygodną
 * postacią logiczną dla formularza. Werdykt ostateczny i tak wydaje usługa
 * tenantów przy zakładaniu.
 */
export function isValidNip(raw) {
    return checkTaxId(String(raw)) === null;
}
export function isValidSlug(slug) {
    if (slug.length < 3 || slug.length > 63)
        return false;
    if (!SLUG_RE.test(slug))
        return false;
    if (SLUG_PUNYCODE_RE.test(slug))
        return false;
    return !RESERVED_SLUGS.has(slug);
}
/** Walidacja pojedynczego kroku kreatora rejestracji operatora (kroki 1–5). */
export function validateSignupStep(step, f, lang = "pl") {
    const m = MSG[lang];
    const e = {};
    if (step === 1) {
        if (!f.companyName || f.companyName.trim().length < 2)
            e.companyName = m.company;
        if (!f.nip || !isValidNip(f.nip))
            e.nip = m.nip;
        if (!f.phone || f.phone.replace(/\D/g, "").length < 9)
            e.phone = m.phone;
        if (!f.address || f.address.trim().length < 5)
            e.address = m.address;
    }
    if (step === 2 && (!f.slug || !isValidSlug(f.slug)))
        e.slug = m.slug;
    if (step === 3 && (!f.industries || !f.industries.length))
        e.industries = m.industries;
    if (step === 4 && !f.plan)
        e.plan = m.plan;
    if (step === 5)
        Object.assign(e, validateAccount(f.admin ?? {}, lang));
    return e;
}
export const VALIDATION_MESSAGES = MSG;
//# sourceMappingURL=validation.js.map